export default {
  addBankAccount: 'افزودن حساب بانکی',
  accountNumber: 'شماره حساب',
  bank: 'بانک',
  carNumber: 'شماره کارت',
  account: 'حساب',
  editBankAccount: 'ویرایش بانکی حساب',
  branchCode: 'کد شعبه',
  branchName: 'نام شعبه',
  cardNumber: 'شماره کارت',
  holderName: 'صاحب حساب',
  shebaNumber: 'شماره شبا',
  createWasSuccessful: 'حساب بانکی با موفقیت اضافه شد',
  editWasSuccessful: 'حساب بانکی با موفقیت ویرایش شد',
  deleteAccountWasSuccessful: 'حساب بانکی با موفقیت حذف شد',
  bankAccount: 'حساب بانکی'
}
